import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import {
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { FreneticityButton } from "../styledElements";
import { useStores } from "../../hooks/useStores.hook";
import { ContentCopy } from "@mui/icons-material";
import { NotificationType } from "../../stores/notification.store";
import styled from "@emotion/styled";

interface NotificationsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const NotificationsModal: FC<NotificationsModalProps> = observer(({ isOpen, onClose }) => {
  const {
    notificationStore: { notifications },
  } = useStores();
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Notifications</DialogTitle>
      <DialogContent>
        <List>
          {notifications
            .slice(0)
            .reverse()
            .map((notification, index) => (
              <ListItem
                component="div"
                key={notification.timestamp.toUnixInteger()}
                style={{ display: "block", position: "relative" }}
              >
                <Color className={notification.type.toString()}></Color>
                <div>
                  <Typography>{notification.summary}</Typography>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography fontSize="small">{notification.timestamp.toFormat("dd/MM/yyyy HH:mm:ss")}</Typography>
                  <Typography fontSize="small">
                    {notification.tags.map(tag => (
                      <Chip size="small" key={tag} label={tag} />
                    ))}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={async () => navigator.clipboard.writeText(notification.message)}
                    title="Copy to clipboard"
                  >
                    <ContentCopy />
                  </IconButton>
                </div>
                {index < notifications.length - 1 && <Divider />}
              </ListItem>
            ))}
        </List>
      </DialogContent>
      <DialogActions>
        <FreneticityButton onClick={onClose}>Close</FreneticityButton>
      </DialogActions>
    </Dialog>
  );
});

const Color = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  width: 2,
  margin: "10px 0px",
  "&.info": {
    backgroundColor: "blue",
  },
  "&.success": {
    backgroundColor: "green",
  },
  "&.warn": {
    backgroundColor: "orange",
  },
  "&.error": {
    backgroundColor: "red",
  },
});
